module.exports = __webpack_public_path__ + "static/Petal 1-8e7faccd38a31f9ff900198aeae27c1c.png";